import type { ReactNode } from "react";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import type { BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";

interface Props extends React.HTMLAttributes<HTMLElement> {
	as?: React.ElementType;
	tooltip: ReactNode;
	variant?: "danger" | "default";
	show?: boolean;
	children?: ReactNode;
}

export const InfoPopup: BsPrefixRefForwardingComponent<"div", Props> = React.forwardRef<HTMLElement, Props>(
	({ as: Component = "div", show = undefined, tooltip = null, variant = "default", ...rest }, ref) => {
		const renderTooltip = (props): ReactNode => {
			return (
				<Tooltip {...props} className={variant === "danger" ? "tooltip-danger" : undefined}>
					{tooltip}
				</Tooltip>
			);
		};

		if (tooltip === null || tooltip === "") {
			return <Component ref={ref} {...rest} />;
		}

		return (
			<OverlayTrigger overlay={renderTooltip} show={show}>
				<Component ref={ref} {...rest} />
			</OverlayTrigger>
		);
	},
);
